class ProductSamples extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('button');
    if (!button) return;

    event.preventDefault();
    const variantId = button.dataset.variantId;
    const handle = this.dataset.handle;
    const sampleType = button.dataset.sampleType || 'standard';

    if (!variantId) {
      console.error('[ProductSamples] No variant ID found on button.');
      return;
    }

    if (button.hasAttribute('disabled')) return;

    this.addSample(button, variantId, handle, sampleType);
  }

  async addSample(button, variantId, handle, sampleType) {
    button.classList.add('btn--loading');
    button.setAttribute('disabled', 'disabled');

    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const cart = cartResponse.ok ? await cartResponse.json() : { items: [] };

      const detail = {
        cart,
        options: { productHandle: handle, sampleType, quantity: 1 },
        allowed: true,
        reason: null,
      };
      document.dispatchEvent(new CustomEvent('sample-limit:validate', { detail }));

      if (!detail.allowed) {
        document.dispatchEvent(
          new CustomEvent('sample-limit-popup:open', {
            detail: { reason: detail.reason, trigger: button },
          }),
        );
        return;
      }

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Failed to add sample to cart.');
      }

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: button },
        }),
      );

      if (window.theme && window.theme.cart) {
        const updatedCart = await theme.cart.getCart();
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: updatedCart },
          }),
        );
      }
    } catch (error) {
      console.error('[ProductSamples] Error:', error);
    } finally {
      button.removeAttribute('disabled');
      button.classList.remove('btn--loading');
    }
  }
}

if (!customElements.get('product-samples')) {
  customElements.define('product-samples', ProductSamples);
}
